// @flow
import styled from '@emotion/styled'
import * as React from 'react'
import type { Mdx } from 'types'

import { colors, media } from '@toggl/style'
import { text } from '@toggl/ui'
import { MDX } from 'components'

type AnnouncementProps = {
  data: Mdx,
}

export default function HeaderAnnouncement({
  data,
  ...props
}: AnnouncementProps) {
  return (
    <StyledTopbar {...props}>
      <TopbarWrapper>
        <MDX>{data}</MDX>
      </TopbarWrapper>
    </StyledTopbar>
  )
}

const StyledTopbar: React.ComponentType<any> = styled.div`
  min-height: 60px;
  background: ${colors.yellow};
  padding: 20px;
  pointer-events: all;

  p,
  a {
    ${text.paragraph3};
    color: ${colors.darkPurple};
  }

  a {
    text-decoration: underline;
    display: inline-block;
    color: ${colors.darkPurple};
  }

  ${media.mq[1]} {
    > div > span {
      margin-top: 0;
      margin-left: 20px;
    }
  }

  position: relative;
`
const TopbarWrapper = styled.div`
  ${media.mq[1]} {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
`
